module.exports = __webpack_public_path__ + "static/media/projectimg.c294cd1b.png";